<template>
  <div class="dialog-alert" :class="{ 'is-bottom-sheet': isBottomSheet }">
    <template v-if="lineLayout == 'Compact' && !isBottomSheet">
      <div class="text-center mb-3">
        <p class="text-text f-title" v-if="text">{{ text }}</p>
      </div>
      <template v-if="note">
        <div class="mb-2">
          <span class="f-bold f-body-lg">หมายเหตุ *</span> <br />
          <span class="f-body">
            {{ note }}
          </span>
        </div>
      </template>
      <div class="text-center" v-if="showIcon">
        <img
          :src="`${$baseUrl}svg/success.svg`"
          alt=""
          class="dialog-alert__icon mb-3"
          aria-hidden="true"
        />
      </div>
    </template>
    <template v-else>
      <div class="text-center mb-3">
        <p :class="[showIcon ? 'text-text f-title' : 'f-body-lg']" v-if="text">
          {{ text }}
        </p>
      </div>
      <div class="text-center" v-if="showIcon">
        <img
          :src="`${$baseUrl}svg/success.svg`"
          alt=""
          class="dialog-alert__icon"
          aria-hidden="true"
        />
      </div>
      <div class="text-center mt-3" v-if="desc">
        <p
          v-if="isDescHtml"
          :class="[showIcon ? 'text-text f-body-lg' : 'f-body-lg']"
          v-html="desc"
        ></p>
        <p v-else :class="[showIcon ? 'text-text f-body-lg' : 'f-body-lg']">
          {{ desc }}
        </p>
      </div>
      <template v-if="note">
        <div class="mb-2">
          <span class="f-bold f-body-lg">หมายเหตุ *</span> <br />
          <span class="f-body">
            {{ note }}
          </span>
        </div>
      </template>
    </template>

    <div class="modal-qr-v2__actions">
      <c-btn
        block
        variant="confirm-primary"
        @click="$emit('confirm')"
        data-test="alert-modal-confirm-btn"
      >
        {{ closeText || $t("confirm") }}
      </c-btn>
      <c-btn
        v-if="isCanCancel"
        block
        variant="outline-primary mt-3"
        @click="$emit('cancel')"
        data-test="alert-modal-cancel-btn"
      >
        {{ cancelText || $t("cancel") }}
      </c-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogAlert",
  emits: ["confirm", "cancel"],
  props: {
    text: {
      type: String,
      default: ""
    },
    closeText: {
      type: String,
      default: ""
    },
    cancelText: {
      type: String,
      default: ""
    },
    note: {
      type: String,
      default: ""
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    isCanCancel: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    },
    isBottomSheet: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    lineLayout() {
      return this.$lineLayout || "";
    },
    isDescHtml() {
      return (
        typeof this.desc === "string" && /<\/?[a-z][\s\S]*>/i.test(this.desc)
      );
    }
  }
};
</script>

<style scoped lang="scss">
.dialog-alert {
  // padding: 24px 16px;

  &.is-bottom-sheet {
    // padding: 32px 16px 24px;
  }
}

.text-text {
  margin-bottom: 0;
  font-weight: 600;
}

svg[data-icon="check-circle"] {
  color: var(--primary-color);
}

.dialog-alert__icon {
  width: 80px;
  height: 80px;
  object-fit: contain;
}
</style>
